import useIsAccessInAutoApprovalGroup from 'modules/approvals/hooks/useIsAccessInAutoApprovalGroup'

export const useHasToRequestPromotion = () => {
  const { loading, isAutoApprover } = useIsAccessInAutoApprovalGroup({ category: 'contracts' })
  return {
    loading: loading,
    hasToRequestPromotion: !isAutoApprover,
  }
}
